import { ComponentType } from 'react';
import ActiveUsersTileMetrics from './active-users-tile-metrics';
import GroupsAndAccessTileMetrics from './groups-and-access-tile-metrics';
import LoginActivityTileMetrics from './login-activity-tile-metrics';
import MasterSchedulerTileContent from './master-scheduler-tile-content';
import RecentAdminActionsTileContent from './recent-admin-actions-tile-content';
import RulesEngineTileMetrics from './rules-engine-tile-metrics';
import {
  CommandDashboardTileDefinition,
  CommandDashboardTileKey,
} from './tile-config';

export interface CommandDashboardTileBodyProps {
  tile: CommandDashboardTileDefinition;
  /**
   * Grid columns the tile spans, which is which of its sizes the body is being
   * drawn at (12 full width, 6 half, 4 a third; 8 for a wide tile's 2/3 size).
   * A body laid out per size should branch on this rather than on a container
   * query - a dashboard narrower than Figma's 1622px canvas draws every size
   * proportionally smaller, so no pixel width identifies a size on its own.
   * Left unset when a body is rendered outside the grid, meaning full width.
   */
  columns?: number;
}

export type CommandDashboardTileBodyComponents = Partial<
  Record<CommandDashboardTileKey, ComponentType<CommandDashboardTileBodyProps>>
>;

/**
 * Bodies for every tile in the library. A tile with its own live data gets a
 * dedicated component here; everything else falls back to DefaultTileContent,
 * which renders the plain shell but still degrades to an insufficient-access
 * notice when the viewer lacks the tile's permission.
 */
export const TILE_CONTENT_COMPONENTS: CommandDashboardTileBodyComponents = {
  activeUsers: ActiveUsersTileMetrics,
  masterScheduler: MasterSchedulerTileContent,
  recentAdminActions: RecentAdminActionsTileContent,
  rulesEngine: RulesEngineTileMetrics,
  loginActivity: LoginActivityTileMetrics,
  groupsAndAccess: GroupsAndAccessTileMetrics,
};
